import { useEffect } from "react";
import "../scss/terms.scss";

interface TermsAndConditionsProps {
  loaderStatus?: (status: boolean) => void;
}

export const TermsAndConditions = ({
  loaderStatus,
}: TermsAndConditionsProps) => {
  // Static page: clear the global loading overlay on mount.
  useEffect(() => {
    loaderStatus?.(true);
  }, [loaderStatus]);

  return (
    <div className="jazz_discount_outer">
      <div className="container">
        <div className="discount_inner">
          <h2>Terms & Condition</h2>
          <h3>JP Terms of Use</h3>
          <p>
            Salam/Greetings! and very warm welcome to the Terms of Use (“Terms
            ”) of Jazz Parho( “Jazz Parho ”,“JP”,“We”,”Us”, or “Our”). A
            remarkable educational application, offers a range of features and
            learning resources to enhance your skills. Its extensive collection
            of materials assists students in improving their grades. The primary
            objective of Jazz Parho is to revolutionize learning by making it
            more effective and accessible. This app provides users with access
            to appropriate course materials tailored to their chosen grades and
            subjects. With top-notch instructors, Jazz Parho undoubtedly
            surpasses traditional tuition methods, offering a superior solution.
            By accessing or using the Platform (defined below) you agree to be
            bound by these Terms. Your agreement with us includes these Terms,
            the Privacy Policy available at{" "}
            <a href="https://jazzparho.com.pk/privacypolicy" target="_blank" rel="noreferrer">https://jazzparho.com.pk/privacypolicy</a>
            <br />
            <br />{" "}
            <b>
              IF YOU DO NOT AGREE WITH THESE TERMS, THEN PLEASE REFRAIN FROM
              USING THE PLATFORM. BY ACCESSING OR USING THE PLATFORM, YOU
              IRREVOCABLY ACCEPT THE AGREEMENT AND AGREE TO ABIDE BY THE SAME
              (AS UPDATED FROM TIME TO TIME).
            </b>
            <br />
            <br />
            If you have downloaded Our PWA / App from Google Play Store, You
            will also be subject to Google Play Terms of Service. If there is
            any conflict between Google Play Terms of Service and this Agreement
            with respect to your use of the App, then, this Agreement shall
            prevail.
          </p>

          <h3>Definitions</h3>
          <p>
            <b>“Subscription” </b> is an access model of the product where
            subscribers get access to the Portal
          </p>
          <p>
            <b>“Subscriber” </b> ” is a User (defined below) who has paid a
            subscription fee as defined to access that content.
          </p>
          <p>
            <b>“Personal Information” </b> means any information that relates to
            a natural person, which, either directly or indirectly, in
            combination with other information available or likely to be
            available with a body corporate, is capable of identifying such
            person.
          </p>
          <p>
            <b>“Platform” </b> means the website available at {" "}
            <a href="https://jazzparho.com.pk" target="_blank" rel="noreferrer">https://jazzparho.com.pk</a> and any sub domains (<b>“Website”</b>)and
            the JP mobile application on Android (<b> “Application”</b>).
          </p>
          <p>
            <b>“Reward” </b>is an award given to a Subscriber for being a top
            scorer in a particular Segment.
          </p>
          <p>
            <b>“Territory” </b> shall mean Pakistan.
          </p>
          <p>
            <b>“Billing Provider”</b> shall mean Jazz.
          </p>

          <h3>Parties to the Agreement</h3>

          <p>
            These Terms describe a contractual agreement between You, the User
            of the Platform, and JP regarding Your use of the Platform. JP has
            the right to refuse access in its discretion for any or no reason.
            Without limiting the foregoing, You specifically acknowledge that JP
            reserves the right to terminate or limit Your access in the event
            that JP determines, in its sole discretion, that You have violated
            the policies of JP or any forum used by You, including the
            activities that adversely affect the experience of other Users.
          </p>

          <h3>Eligibility Criteria for User(s)</h3>
          <p>
            You must be of legal age as applicable in local law or at least 4
            years of age to access and use the JP Platform. If You are between
            the age of 4 to 17 years, your access to the Platform should be
            permitted by Your parent or legal guardian. You (or Your
            parent/guardian) must agree to be bound by these Terms; You must be
            a resident of the country the billing provider you have used to
            enter is operating in; If You do not meet any or all of these
            criteria, please DO NOT use the JP Platform.{" "}
          </p>

          <h3>General Disclaimers</h3>
          <p>
            By use of the Platform, You agree that You meet with the Eligibility
            Criteria as detailed in Clause 2 (above) and that You are fully able
            and competent to understand and accept this Agreement as a binding
            contract and to abide by all Terms.
            <br />
            <br />
            You shall not access the Platform by any other means other than
            through the interfaces that are provided by JP and not acquire,
            copy, or monitor any portion of the Platform in any way to reproduce
            or circumvent the navigational structure or presentation of the
            Platform, to obtain or attempt to obtain any materials, documents,
            or information through any means not specifically made available
            through the Platform.
            <br />
            <br />
            You shall not host, display, upload, modify, publish, or share any
            information on the Platform that belongs to another person to which
            You do not have any right to; or is grossly harmful, blasphemous,
            defamatory, obscene, pornographic, pedophilic, libelous, invasive of
            another’s privacy, hateful, racially objectionable, disparaging,
            relating to encouraging money laundering or gambling or otherwise
            unlawful in any manner; or
            <br />
            <br />
            engages in any activity that interferes with or disrupts access to
            the Platform or JP servers / networks; or <br />
            <br />
            falsifies or deletes any author attributions, legal or other
            notices, proprietary designations, label soft he origin or source of
            software ,or other material on the Platform.
            <br />
            <br></br>
            JP shall not be liable for any misuse of the Personal Information
            shared by You with Us or a third party on Your profile on the
            Platform.
            <br />
            <br />
            JP reserves the right to change the Terms from time to time, and
            such changes will be applicable to You if You continue to use the
            Platform at any time after such changes are posted on the Platform.
            Where We believe that any changes are material, We will notify You
            through either an in-app notification, or SMS, or push
            notifications, or email You have provided Us, but regardless of
            whether You receive such notice, any changes will become effective
            if You use any of the Platform at any time after such changes are
            published on this page. We recommend that you visit this page
            periodically to be sure You are aware of the most recent Terms.
            <br />
            <br />
            If You do not agree to these Terms, do not use any of the Platform,
            and if You do not wish to agree to any changes to these Terms,
            please cease using the Platform.
          </p>

          <h3>Service Subscription and un-subscription:</h3>
          <div>
            Service Subscription: The service is provided to Billing Provider’s
            customers at a subscription fee and this subscription can be
            purchased at <a href="https://jazzparho.com.pk" target="_blank" rel="noreferrer">https://jazzparho.com.pk</a> and other advertising
            links as promoted by JP
            <br />
            <br />
            Subscribers can opt for the following subscription plan(s) to avail
            access to JP.
            <br />
            <br />
            <table style={{ border: "2px solid black" }}>
              <thead></thead>
              <tbody>
                <tr>
                  <td>Pricing Model</td>
                  <td>Price Exclusive Tax</td>
                  <td>Price with tax</td>
                  <td>Validity(days)</td>
                </tr>

                <tr>
                  <td>Daily</td>
                  <td>6</td>
                  <td>7.17</td>
                  <td>1</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />

          <h3>Conditions for providing information to Service users:</h3>
          <p>
            During Service activation, the subscriber consents to receiving text
            messages for new features/updates in JP. Text messages are sent from
            Billing Provider’s Network which does not incur any charges. JP
            reserves the right to change the subscription fee or run special
            offers from time to time in which it can offer discounted or free
            subscription to Billing Provider’s customers.
          </p>

          <h3 style={{ fontWeight: "bold" }}>JP’s Rights</h3>
          <h3>JP shall:</h3>
          <p>
            P reserve the right to change the accepted method of payment or
            billing provider at its sole discretion;
          </p>

          <h3>No Guarantees</h3>
          <p>
            Among other things, JP does not guarantee that:
            <br />
            <br />
            The Platform will meet the User’s expectations; or
            <br />
            <br />
            The Platform will be accessible without interruption or in a timely,
            reliable, or fault- free manner; or
            <br />
            <br />
            The results obtained through use of the Platform will be as per
            users expectations deemed as correct and reliable; or
            <br />
            <br />
            The quality of the products, services, information, or other
            material Won or obtained by the User through the Platform will meet
            the User’s expectations.
            <br />
            <br />
            The User shall be solely responsible for damages to his or her data
            system or for loss of data arising from downloads of content from
            the Platform.
            <br />
            <br />
            No guidance or information, written or oral, obtained from JP or via
            the Platform, shall constitute any warranty, which has not
            specifically been stated in these Terms.
          </p>

          <h3>Limitation of Liability</h3>
          <p>
            Users specifically acknowledge and agree that in no event shall JP
            be liable for any direct or indirect damage, including but not
            limited to, delay, damages caused by unused opportunity of the
            Platform, loss of profits, goodwill, licenses of data, or other
            financial loss arising out of: the use of the Platform or inability
            to use the Platform; costs arisen from acquiring are placement of
            any product or service that is based on any item, data, information,
            or service purchased through the Platform, from any message received
            through the Platform or any transactions made by means of the
            Platform; third party claims against the subscriber; unlawful access
            to or modifications of data transmissions; or any other
            circumstances related to the Platform.
            <br />
            <br />
            JP exempts itself from any claims for damages relating to the
            Platform access, function, quality, possible errors such as spelling
            errors, bugs, and other factors relating to the Platform.
            <br />
            <br />
            JP shall not be liable for any indirect or unforeseeable damages
            caused to the Users under any given circumstances.
            <br />
            <br />
            The User(s) shall maintain confidentiality of his/her User
            credentials and shall be responsible for any access made through
            his/her account. The User shall immediately notify JP of any actual
            or suspected unauthorized use of User’s credentials and may be
            liable for the JP’s losses or such other parties as the case may be,
            due to any unauthorized use.
          </p>

          <h3>Force Majeure</h3>
          <p>
            JP shall not be liable for any damages what so ever arising out of
            force majeure or other similar circumstances, directly or indirectly
            affecting JP and unreasonably complicating JP’s activities. Examples
            of force majeure events are real or potential labour disputes,
            governmental actions, war or threat of war, sabotage, civil unrest,
            demonstrations, fire, storm, flooding, explosion, earthquake,
            provisions or limitations of materials or resources, inability to
            obtain the relevant authorization, accident, and defect in
            electricity or telecommunication network. Force majeure or other
            event beyond JP’s control hindering, delaying or complicating the
            maintenance of the Platform entitles the JP to suspend or limit the
            Platform until further notice.
          </p>

          <h3>Intellectual Property Rights</h3>
          <p>
            The content of the Platform is protected by international copyright
            acts and treaties. All reproduction or distribution of any material
            on the Platform, including but not limited to text, photographs,
            movies, music and software programs is strictly prohibited, unless
            explicitly stated otherwise. JP reserves any and all rights not
            expressly granted herein.
            <br />
            <br />
            JP’s trade name, logotype, and all related trademarks, product
            and/or service names and slogans used in the Platform are the
            property of JP and may not be used in any way without the prior
            written approval of JP. Users use of the Platform shall not be
            construed as the grant of any license or right to use any trademarks
            or names appearing on the Platform.
          </p>

          <h3>Advertisements</h3>
          <p>
            JP may include or offer third party products on the Platform through
            digital advertisements, whether fetched directly from advertisers or
            sourced from ad networks JP shall not be liable for any privacy
            practices or the content shared by the business partners,
            advertisers, sponsors or other websites to which JP provides links
            on the Platform. The Users shall be responsible for checking the
            privacy policy and terms of use of such third- parties before
            exploring their websites to safeguard their interests.
          </p>

          <h3 style={{ fontWeight: "bold" }}>Term and Termination</h3>
          <p>
            <b className="term-bold">Term: </b> This Agreement is valid until
            further notice.
            <br />
            JP may at its sole discretion and without prior notice, suspend/
            freeze/ terminate the User’s access to the Platform if he/she
            violates or attempts to violate the security of the Platform
            including, without limitation:
            <br />
            accessing data not intended for You or logging on to a server or the
            User is not authorized to use; attempting to probe, scan or test the
            vulnerability of the system or network or to breach security or
            authentication measures without authentication; or
            <br />
            accessing or using the Platform without authorization, in violation
            of these Terms or in violation of applicable law.
            <br />
            Violations of system or network security may result in civil or
            criminal liability. JP will investigate occurrences that may involve
            such violations and cooperate with law enforcement authorities in
            prosecuting Users who are involved in such violations. You agree not
            to use any device, software, or routine to interfere or attempt to
            interfere with the proper working of this Platform or any activity
            being conducted on this Platform.
            <br />
            JP may at its sole discretion and without prior notice, suspend,
            freeze or terminate the Subscriber Account under the following
            circumstances:
            <br />
            <br />
            The Subscriber violates any or all terms of this Agreement or
            instructions on the Platform;
            <br />
            JP has reason to suspect a crime, misuse, fraud, or attempt of such
            in relation to use of the Platform;
            <br />
            JP considers it to be necessary for safety reasons or JP’s
            reputation; or
            <br />
            JP is forced to do so pursuant to legislation or ruling of a
            competent authority.
            <br />
            <br />
          </p>
          
          <h3>Indemnity</h3>
          <p>
            The Users shall indemnify, defend, and hold harmless JP and its
            affiliates, if any, from and against any and all losses,
            liabilities, claims, suits, proceedings, penalties, interests,
            damages, demands, costs, and expenses (including legal and
            statutory fees and disbursements in connection therewith and
            interest chargeable thereon) asserted against or incurred by JP
            that arise out of, result from, or in connection with:
            <br />
            the User’s breach of these Terms;
            <br />
            any claims made by any third party due to, or arising out of, or
            in connection with User’s use of JP Platform or participation in a
            Campaign on the Platform or winning/claiming the reward of such
            Campaign;
            <br />
            the User’s violation of any rights of another, including
            intellectual property rights;and the User’s violation of any
            applicable laws.
            <br />
            Not with standing anything to the contrary in these Terms, in no
            event shall JP and its affiliates, if any, be liable to the User
            or anyone claiming through the User in respect of any subject
            matter of these Terms.
          </p>

          <h3>Applicable Law and Jurisdiction</h3>
          <p>
            These Terms shall be governed by the laws of territory. You agree
            that JP is solely based in Islamabad Pakistan, and nothing shall
            give rise to personal jurisdiction over us in jurisdictions other
            than Pakistan and you shall not raise any claims against us in any
            court or forum in any jurisdiction other than Pakistan
            <br />
            Any claim or dispute between the Subscriber and JP will be
            entertained and tried solely and exclusively by a court of
            competent jurisdiction located in Pakistan and no other place
            whatsoever.
          </p>

          <h3>Severability</h3>
          <p>
            If, for any reason, a court of competent jurisdiction finds any
            provision of the Terms, or portion there of, to be unenforceable,
            that portion shall be enforced to the maximum extent permissible
            so as to give effect to the intent of the parties as reflected by
            that provision. The remainder of the Terms shall continue in full
            force and effect.
          </p>

          <h3>Waiver</h3>
          <p>
            No provision of this Agreement shall be deemed to be waived and no
            breach excused, unless such waiver or consent shall be in writing
            and signed by JP. Any consent by JP to, or a waiver by JP of any
            breach by the User, whether expressed or implied, shall not
            constitute consent to, waiver of, or excuse for any other
            different or subsequent breach.
          </p>

          <h3 style={{ fontWeight: "bold" }}>
            Live Quiz Show Terms and conditions
          </h3>
          <h3 style={{ fontWeight: 400, color: "black" }}>
            Key Features/Mechanics:
          </h3>
          <ul>
            <li>
              Live Quiz show is a fun filled and learning based engagement
              activity designed, and run by owners of Parho App/Platform
              (i.e., eConception Pvt Ltd) – <b>“Parho App”</b> in
              collaboration of Jazz for its prepaid subscribers.{" "}
            </li>
            <li>
              Live quiz show is simply to answer questions and win amazing
              incentive from Parho App.
            </li>
            <li>
              The valid subscribers of Parho App will be able to access the
              Parho Quiz on the Parho App.{" "}
            </li>
            <li>
              There will be 10-20 questions per day during the daily Live quiz
              show.
            </li>
            <li>
              The result of the winner of the Quiz will be displayed on
              <br />
              Mobile app
              <a href="https://play.google.com/store/apps/details?id=com.jazzeducator" target="_blank" rel="noreferrer">
                (https://play.google.com/store/apps/details?id=com.jazzeducator)
              </a>
              <br />
              Instagram
              <a href="https://instagram.com/jazzparho?igshid=MzRlODBiNWFlZA==" target="_blank" rel="noreferrer">
                {" "}
                (https://instagram.com/jazzparho?igshid=MzRlODBiNWFlZA==)
              </a>
              .
            </li>
            <li>
              Parho App will announce one (01) winner per day at the end of
              daily Live Quiz Show from the participants.
            </li>
            <li>
              The highest score of correct answers in minimum/shortest time
              will be the criteria to win the incentives from Parho App.
            </li>
            <li>
              The qualified Winners will be entitled to the following
              Incentives:
              <ul>
                <li style={{ listStyleType: "circle" }}>
                  Daily Data Bundle - Monthly 3GB
                </li>
              </ul>
            </li>
            <li>
              Valid subscribers of Parho App from Jazz Prepaid subscriber-base
              can participate in Live quiz show free of cost.
            </li>
            <li>
              Parho App will request Jazz to post the free incentive, i.e.,
              Daily Data bundle to the winner after verification of his
              credentials within a period of 3 working days.
            </li>
          </ul>

          <h3 style={{ color: "black" }}>Winning Criteria:</h3>
          <ul>
            <li>
              The participant of Quiz Trivia with maximum correct answers in
              minimum/shortest time will be declared as winner of that day.
            </li>
          </ul>

          <h3 style={{ color: "black" }}>Terms & Conditions</h3>
          <ul style={{ lineHeight: "35px" }}>
            <li>
              Entitlement of daily data bundle will be valid for the
              participation in daily Live quiz show.
            </li>
            <li>
              The time period for the Live Quiz Show will be displayed at the
              App.
            </li>
            <li>
              A winner who has already won in the last 30 days would not be
              considered.
            </li>
            <li>
              Valid subscribers of Parho App from Jazz Prepaid subscriber-base
              can participate in Live quiz show free of cost and can win
              incentives.
            </li>
            <li>
              Employees of Jazz and Parho App (i.e., eConceptions) will not be
              eligible for participation and incentives of this Live Quiz Show
              activity.
            </li>
            <li>
              Score will be calculated based on first correct answer + fastest
              response in minimum time.
            </li>
            <li>
              The name of the winner shall appear on Parho App and other
              digital platforms, if any, as per discretion of Parho App.
            </li>
            <li>
              All queries/complaints/suggestions shall sent to {" "}
              <a href="mailto:support@econceptions.mobi">support@econceptions.mobi</a>
            </li>
            <li>
              Parho App may change any of the terms and conditions of this
              Quiz Trivia at any time as per its discretion.
            </li>
            <li>
              Incentives given in the Quiz Trivia are non-transferable and
              cannot be exchanged for cash or other alternatives.
            </li>
            <li>
              Participation of a subscriber of Parho App, in Live quiz show,
              shall be considered that the subscriber has:
              <ul>
                <li style={{ listStyleType: "circle" }}>
                  accepted the terms and conditions of this Quiz Trivia
                  available on Parho App with his “free consent”.
                </li>
                <li style={{ listStyleType: "circle" }}>
                  given his “free consent” for showing his name/credentials on
                  Parho App or other social media/leaderboard.
                </li>
              </ul>
            </li>
            <li>
              The subscriber who does not agree to the aforesaid conditions,
              will not be eligible to participate and may quit the Live quiz
              show.
            </li>
            <li>
              The subscriber participating in the Live quiz show cannot
              question the terms and conditions including any changes in terms
              and conditions nor raise objection on showing his
              name/credential on digital platforms or consent thereafter.
            </li>
            <li>
              If for any reason the Live quiz show does not run for its entire
              duration due to a computer virus, tampering, unauthorized
              intervention, fraud, technical failures, or any other cause
              beyond the reasonable control of the Parho App, the Parho App
              then reserves the right in its sole discretion, to (a)
              disqualify any entrant or (b) modify, suspend, terminate or
              cancel the Quiz Trivia/activity, as appropriate.
            </li>
            <li>
              Other terms and conditions of Parho App available at {" "}
              <a href="https://jazzparho.com.pk" target="_blank" rel="noreferrer">https://jazzparho.com.pk</a> will also be applicable.
            </li>
          </ul>

          <h3 style={{ fontWeight: "bold" }}>
            Subscribe & Win Contest T&C (Not Active Now)
          </h3>
          <h3>Reward:</h3>
          <h3 className="black-heading">Rs. 10,000 Monthly</h3>
          <ul>
            <li>
              1 winner will be selected through a lucky draw for Rs. 10,000
              cash prize every month.
            </li>
          </ul>
          <h3>Winner Announcement:</h3>
          <ul>
            <li>
              Winners will be selected randomly from all eligible entries.
            </li>
            <br />
            <li>
              The organizers' decision regarding the selection of winners is
              final and binding.
            </li>
            <br />
            <li>
              The winner will be notified via Call and SMS within 72 hours of
              the winning date{" "}
            </li>
            <br />
            <li>
              The names of winners will also be announced on the Instagram and
              Facebook accounts.
            </li>
          </ul>
          <h3>Terms and Conditions:</h3>
          <ul>
            <li>
              To claim prizes, the user must have been successfully charged at
              least once a month
            </li>
            <br />
            <li>
              The user will be chosen from the list of subscribers of the
              existing month.{" "}
            </li>
            <br />
            <li>
              We reserve the right/discretion to set/change the price/rate of
              any offer or withdraw from the Subscribe & Win campaign at any
              time.
            </li>
            <br />
            <li>
              By participating in the lucky draw, winners grant the organizers
              the right to use their names, photos, and related information
              for promotional purposes.
            </li>
            <br />
            <li>
              The winner must be a citizen of Pakistan and he/she has a Jazz
              cash account associated with the winning number.{" "}
            </li>
            <br />
            <li>
              Prizes are non-transferable and cannot be exchanged for cash or
              other alternatives.
            </li>
            <br />
            <li>
              The organizers reserve the right to substitute a prize with
              another of equal or higher value if necessary.
            </li>
            <br />
            <li>
              Employees, affiliates, and immediate family members of the
              organizing company are not eligible to participate.
            </li>
            <br />
            <li>
              The organizer’s decision is final and no correspondence or
              complaints will be entertained.
            </li>
            <br />
            <li>
              Winner needs to provide a photograph that will be used for
              marketing and media purposes and the Organizer has the right to
              use these images without seeking prior approval of the prize
              winner.
            </li>
            <br />
            <li>
              The organizer reserves the right to amend or change these terms
              and conditions at their discretion.
            </li>
            <br />
            <li>
              If for any reason the competition does not run for its entire
              duration due to a computer virus, tampering, unauthorized
              intervention, fraud, technical failures or any other cause
              beyond the reasonable control of the Organizer, the Organizer
              then reserves the right, in its sole discretion, to (a)
              disqualify any entrant or (b) modify, suspend, terminate or
              cancel the promotion, as appropriate.
            </li>
            <br />
            <li>
              No user can claim the reward or Mobile data more than mentioned
              or announced or decided by us.
            </li>
          </ul>
          <h3>Limitation of Liability: </h3>
          <ol className="limitation-ol">
            <li>
              The organizers are not responsible for any loss, damage, or
              injury resulting from participation in the lucky draw or the use
              of prizes.
            </li>
            <br />
            <li>
              Participants agree to release the organizers from any liability
              associated with the lucky draw and cannot claim anything through
              a legal case for damages.
            </li>
          </ol>
          <h3>Disqualification:</h3>
          <ul>
            <li>
              If the call center contacts the users and they don't respond
              within 24 hours, they would be disqualified.
            </li>
            <br />
            <li>
              The organizers reserve the right to disqualify participants who
              violate the terms and conditions or engage in fraudulent
              activities.
            </li>
            <br />
            <li>
              The organizers reserve the right to modify, suspend, or
              terminate the lucky draw at any time without prior notice.
            </li>
          </ul>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};
